module.exports = __webpack_public_path__ + "static/media/BOMB.8219ac1f.png";